import { PureComponent } from "react";
import { formatMessage } from 'umi/locale';

export default class Empty extends PureComponent {
    render() {
        const emptyStr = formatMessage({ id: "<空>" });
        return <span style={{ color: 'grey', ...this.props.style }}>{emptyStr}</span>;
    }
}
